import { H2, H4, Paragraph, SmallParagraph, SmallText } from "../../components/typography/Typography"
import retract1 from '../../assets/retract1.webp'
import retract2 from '../../assets/retract2.png'
import retract3 from '../../assets/retract3.png'

const steps = [
    { image: retract1, title: 'Expand Seating', description: 'Pull out seating for an audience' },
    { image: retract2, title: 'Retract Chairs', description: 'Pull back chairs electronically/manually' },
    { image: retract3, title: 'Store Away', description: 'Use your floor space for other activities' },
]

export const WhatIsTelescopic = () => {
    return (
        // Mobile: heading block, then video, then steps (single column).
        // Desktop: video pinned to the left column, heading + steps stacked on the right.
        <div className='grid grid-cols-1 gap-8 px-4 md:px-24 lg:grid-cols-5 lg:items-start lg:gap-x-12 lg:gap-y-4'>
            <div className='flex flex-col gap-4 lg:col-start-3 lg:col-span-3 lg:row-start-1'>
                <SmallText>How it works</SmallText>
                <H2>What is Telescopic Seating?</H2>
                <Paragraph className='text-gray-600 max-w-2xl'>
                    It's a system of tiered rows of seats (like bleachers) that can be retracted or extended, often automatically. This technology allows large venues to quickly change from event mode (with seating) to open space (for trade shows, sports).
                </Paragraph>
            </div>

            <div className='flex justify-center lg:col-start-1 lg:col-span-2 lg:row-start-1 lg:row-span-2 lg:self-center'>
                <video
                    src='/telescopic-seating-demo.mp4'
                    width={720}
                    height={1280}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload='metadata'
                    aria-label='Telescopic seating extending and retracting'
                    className='w-full max-w-[280px] lg:max-w-[340px] h-auto aspect-[720/1280] object-cover rounded-xl'
                />
            </div>

            <ol className='flex flex-col gap-3 max-w-2xl lg:col-start-3 lg:col-span-3 lg:row-start-2'>
                {steps.map((step, index) => (
                    <li
                        key={step.title}
                        className='group flex flex-row items-center gap-4 rounded-xl border border-gray-200 bg-white p-3 transition-colors hover:border-gray-300 hover:bg-gray-50'
                    >
                        <div className='flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-gray-100'>
                            <img
                                src={step.image}
                                alt={step.title}
                                loading='lazy'
                                decoding='async'
                                className='max-h-full max-w-full object-contain transition-transform group-hover:scale-105'
                            />
                        </div>
                        <div className='flex flex-col gap-0.5'>
                            <SmallText className='text-gray-400'>Step {index + 1}</SmallText>
                            <H4>{step.title}</H4>
                            <SmallParagraph className='text-gray-600'>{step.description}</SmallParagraph>
                        </div>
                    </li>
                ))}
            </ol>
        </div>
    )
}
